/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { gql } from '@apollo/client';
export type DonationSettingsFragment = { __typename?: 'DonationSettings', default?: any | null, custom?: { __typename?: 'CustomDonationSettings', productType?: any | null, donationContext?: any | null, onlyNameAndEmailForm?: boolean | null } | null };

export const DonationSettingsFragmentDoc = gql`
    fragment DonationSettings on DonationSettings {
  custom {
    productType
    donationContext
    onlyNameAndEmailForm
  }
  default
}
    `;